const showChart = el => { 
    const charts = document.querySelectorAll('.chart')
    const chartButtons = document.querySelectorAll('[data-chartBtn]')
    const thisBtn = document.querySelector(`[data-chartBtn="${el}"]`)
    const thisChart = document.querySelector(`[data-chart="${el}"]`)

    charts.forEach(c => c.classList.remove('active'))
    chartButtons.forEach(c => c.classList.remove('active'))

    thisBtn.classList.add('active')
    thisChart.classList.add('active')

}


// //============================================
// // Meistverkaufte Hörgeräte
// //============================================

// if (document.getElementById('chart1')) {

//     var ctx = document.getElementById('chart1');
//     var myChart = new Chart(ctx, {
//         type: 'bar',
//         data: {
//             labels: ['Hörgerät', 'Hörgerät', 'Hörgerät', 'Hörgerät', 'Hörgerät', 'Hörgerät', 'Hörgerät', 'Hörgerät', 'Hörgerät', 'Hörgerät'],
//             datasets: [{
//                 data: [970, 1200, 980, 1800, 650, 1000, 1250, 2000, 1000, 1200],
//                 backgroundColor: 'rgba(110,187,242, 0.5)',
//                 borderColor: [
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
                
//                 ],
//                 borderWidth: 1
//             }]
//         },
    
//         options: {
//             legend: { display: false },
//             tooltips: {
//                 callbacks: {
//                     label: function (tooltipItem, data, index) {
//                         var index = tooltipItem.index + 1
//                         return 'Platz ' + index
//                     }
//                 },
//             },
//             scales: {
//                 yAxes: [{
//                     ticks: {
//                         beginAtZero: true,
//                         callback: function (value, index, values) {
//                             return '€ ' + value;
//                         }
//                     }
//                 }]
//             }
//         }
//     });
// }




// //============================================
// // Meistverkaufte Hörgeräte 2
// //============================================

// if (document.getElementById('chart2')) {

//     var ctx = document.getElementById('chart2');
//     var myChart = new Chart(ctx, {
//         type: 'doughnut',
//         data: {
//             labels: ['Hörgerät', 'Hörgerät', 'Hörgerät', 'Hörgerät', 'Hörgerät'],
//             datasets: [{
//                 data: [37,13, 14, 26, 10],
//                 backgroundColor: [
//                     'rgba(110,187,242, 0.5)',
//                     'rgba(245,22,34, 0.5)',
//                     'rgba(200,100,242, 0.5)',
//                     'rgba(110,187,242, 0.5)',
//                     'rgba(110,187,242, 0.5)',
//                     'rgba(110,187,242, 0.5)',
//                 ],
//                 borderColor: [
//                     'rgba(110,187,242, 1)',
//                     'rgba(44,187,59, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
//                     'rgba(110,187,242, 1)',
                
//                 ],
//                 borderWidth: 1
//             }]
//         },
    
//         options: {
//             legend: { display: true },
//             tooltips: {
//                 // callbacks: {
//                 //     label: function (tooltipItem, data, index) {
//                 //         var index = tooltipItem.index + 1
//                 //         return 'Platz ' + index
//                 //     }
//                 // },
//             },
//             scales: {
//                 yAxes: [
//                     {display: false},
//                     {
//                     ticks: {
//                         beginAtZero: true,
//                         // callback: function (value, index, values) {
//                         //     return '€ ' + value;
//                         // }
//                     }
//                 }]
//             }
//         }
//     });
// }